<div id="ticketGuestList">
    <app-header title="Manage Guests"></app-header>
    <div id="ticketActionHeaderModal" class="paybee-modal-header paybee-modal-header--regular" style="border:none;">
        <div class="px-3 pt-5 mb-4">
            <div class="paybee-modal-header__regular">
                <div class="mb-4">
                    <a style="color: RGB(0, 118, 255);cursor:pointer;" [routerLink]="['/manage/tickets-and-guests/campaign', ticketsAndGuestStateService.selectedCampaignId]" fragment="ticketsTab">← Back to Tickets</a>
                </div>
            </div>
            <div class="paybee-modal-header__success">
                <div class="d-flex align-items-center mb-4">
                    <i class="fas fa-check-circle headline-2--weight-900 mr-3" style="color:RGB(65, 145, 41)"></i>
                    <div class="d-block">
                        <div class="headline-5 mb-2">Success</div>
                        <div class="body-2">Ticket for <b id="ticketFor">Name</b> has been created.</div>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12">
                    <div class="d-flex">
                        <div class="d-block w-100">
                            <div class="ticket-summary__holder headline-5 mb-2" id="holderName">Holder Name</div>
                            <div class="ticket-summary__type body-1 grey-text" id="ticketType">Ticket Type</div>
                        </div>
                        <div class="d-block">
                            <div class="d-flex w-100">
                                <div id="captainsViewContainer" style="display: none;">
                                    <button type="button" data-toggle="dropdown" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap dropdown-toggle"><img src="/images/png/user-police/icon.png" height="15" width="15" class="mr-2" />Captain’s View</button>
                                    <ul class="dropdown-menu dropdown-menu-right">
                                        <li class="dropdown-item body-1" id="captainsView"><a>Open URL</a></li>
                                        <li class="dropdown-item body-1" id="copyCaptainsView"><a>Copy URL</a></li>
                                    </ul>
                                </div>
                                <div id="reminderContainer">
                                    <button type="button" data-toggle="dropdown" class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap">
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        <span class="mr-2">Reminders</span>
                                        <i class="fas fa-caret-down"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-right">
                                        <li class="dropdown-item body-1" id="ticketSendReminder"><a>Event Reminder...</a></li>
                                        <li class="dropdown-item body-1" id="ticketSendAddGuestReminder"><a>Add Guest Reminder...</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-3">
                    <div class="d-flex align-items-center">
                        <i class="fas fa-chair mr-2"></i>
                        <div class="body-1"><span id="ticket-reserved-seats">0</span> of <span id="ticket-total-seats">0</span> Reserved</div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="d-flex align-items-center">
                        <i class="fas fa-paper-plane mr-2"></i>
                        <div class="body-1"><span id="ticket-invited-guests">0</span> Invite(s) Pending</div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="d-flex align-items-center">
                        <i class="fa fa-check mr-2 green-text"></i>
                        <div class="body-1"><span id="ticket-accepted-guests">0</span> Accepted</div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="d-flex align-items-center">
                        <i class="fas fa-ban mr-2 red-text"></i>
                        <div class="body-1"><span id="ticket-declined-guests">0</span> Declined</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body" id="ticketGuestListContent">
        <ul class="nav nav-tabs md-tabs md-tabs--paybee paybee-modal-header--regular-important py-0 mx-n3 mt-n3" style="padding: 0px calc(19.2px + 16px) !important;" role="tablist">
            <li class="nav-item">
                <a class="nav-link active px-0 mr-4" id="ticketConfirmedGuestsTabNav" data-fragment="ticketConfirmedGuestsTab" href="#ticketConfirmedGuestsTab" role="tab" aria-controls="ticketConfirmedGuestsTab"
                   aria-selected="true">Confirmed Guests</a>
            </li>
            <li class="nav-item">
                <a class="nav-link px-0 ml-4" id="ticketInvitedGuestsTabNav" data-fragment="ticketInvitedGuestsTab" href="#ticketInvitedGuestsTab" role="tab" aria-controls="ticketInvitedGuestsTab"
                   aria-selected="false">Invitations</a>
            </li>
        </ul>
        <div class="tab-content pt-5">
            <div class="tab-pane fade show active" id="ticketConfirmedGuestsTab" role="tabpanel" aria-labelledby="ticketConfirmedGuestsTabNav">
                <div id="guests-section" class="py-4" style="display: none;">
                    <div id="add-guests-section" class="d-none align-items-center">
                        <div class="d-flex align-items-center w-100">
                            <img class="mr-3" src="/images/svg/quickpay/user-checkmark.svg" height="40" width="40" />
                            <div class="d-block">
                                <div class="subtitle-1 mb-1">Confirmed Guests</div>
                                <div class="body-2">Confirmed Guests</div>
                            </div>
                        </div>
                        <button id="assignTableToAllBtn" class="btn btn--paybee text-nowrap btn--outline-transparent btn--padding10x15 button btn--solid-border mr-2 text-nowrap" style="display: none;">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" class="mr-1" height="15">
                                <path d="M22 4H3a2 2 0 0 0 0 4v13.5a.5.5 0 0 0 .5.5h1a.51.51 0 0 0 .5-.43L6.65 10h11.7L20 21.57a.51.51 0 0 0 .5.43h1a.5.5 0 0 0 .5-.5V8a2 2 0 0 0 0-4zM4.07 21H4V8h1.92zM6.79 9l.14-1h11.14l.14 1zM21 21h-.07L19.08 8H21zm1-14H3a1 1 0 0 1 0-2h19a1 1 0 0 1 0 2z" style="fill:#231f20" data-name="side table"/>
                            </svg>
                            Assign Table To All...
                        </button>
                        <button id="addGuestsButton" class="btn btn--paybee btn--green button disabled" style="min-width: 125px;">Add Guests...</button>
                    </div>
                    <div id="confirmed-guests-list" class="confirmed-guests-list mt-3" style="display:none;">
                        <div class="confirmed-guests-list__header d-flex align-items-center mb-1">
                            <div class="confirmed-guests-list__column caption w-100">Name</div>
                            <div class="confirmed-guests-list__column caption w-100">E-Mail</div>
                            <div class="confirmed-guests-list__column confirmed-guests-list__column--dropdown caption w-100" style="min-width:135px">Table #</div>
                            <div class="confirmed-guests-list__column confirmed-guests-list__column--dropdown caption w-100" style="min-width:135px">Seat #</div>
                            <div id="confirmed-guests-list-golfHoleColumn" class="confirmed-guests-list__column confirmed-guests-list__column--dropdown caption w-100" style="min-width:135px">Hole #</div>
                            <div id="confirmed-guests-list-golfCartColumn" class="confirmed-guests-list__column confirmed-guests-list__column--dropdown caption w-100" style="min-width:135px">Cart #</div>
                            <div class="confirmed-guests-list__column caption w-100" style="max-width:100px; white-space: nowrap;">Paddle #</div>
                            <div class="confirmed-guests-list__column caption w-100"></div>
                        </div>
                        <div id="confirmed-guests-container" class="confirmed-guests-list__body">
                        </div>
                    </div>
                    <div id="empty-confirmed-guests-list" class="invitation-list mt-3" style="display:none;">
                        <div class="d-flex flex-column align-items-center my-5">
                            <img class="mb-3" src="/images/svg/quickpay/user-checkmark.svg" height="44" width="44">
                            <div class="headline-5 mb-2">Confirmed Guests</div>
                            <div class="body-1 grey-text mb-4">People confirmed to be attending</div>
                            <div class="body-2 mb-4 d-flex flex-column align-items-center">
                                <div class="mb-1">You have no confirmed guests yet.</div>
                                <div class="mb-1">Use the button below to <span class="green-text">Add Guests</span> to this ticket.</div>
                                <div>Required for Table and Paddle Assignments.</div>
                            </div>
                            <button id="addGuestsButton2" class="btn btn--paybee btn--green button disabled" style="min-width: 125px;">Add Guests...</button>
                        </div>
                    </div>
                </div>
                <div id="confirmed-guests-list-instruction">
                    <div class="d-flex flex-column align-items-center my-5">
                        <img class="mb-3" src="/images/svg/quickpay/user-checkmark.svg" height="44" width="44">
                        <div class="headline-5 mb-2">Confirmed Guests</div>
                        <div class="body-1 mb-5">This functionality is currently disabled.</div>
                        <div class="instruction p-4">
                            <div class="body-2 mb-2">Instruction to enable Confirmed Guests:</div>
                            <div class="body-2">1. Please enable Collect Guest Information</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="ticketInvitedGuestsTab" role="tabpanel" aria-labelledby="ticketInvitedGuestsTabNav">
                <div id="invitation-section" class="py-4" style="display: none;">
                    <div id="invite-guests-section" class="d-flex align-items-center">
                        <div class="d-flex align-items-center w-100">
                            <img class="mr-3" src="/images/svg/quickpay/mail-circle-large@2x.svg" height="40" width="40" />
                            <div class="d-block">
                                <div class="subtitle-1 mb-1">Invitations</div>
                                <div class="body-2">Invite people to attend via email</div>
                            </div>
                        </div>
                        <button id="inviteGuestsButton" class="btn btn--paybee btn--green button disabled" style="min-width: 125px;">Invite</button>
                    </div>
                    <div id="invitation-list" class="invitation-list mt-3" style="display:none;">
                        <div class="invitation-list__header d-flex align-items-center mb-1">
                            <div class="invitation-list__column caption w-100">Name</div>
                            <div class="invitation-list__column caption w-100">E-Mail</div>
                            <div class="invitation-list__column caption w-100">Count</div>
                            <div class="invitation-list__column caption w-100">Status</div>
                            <div class="invitation-list__column caption w-100"></div>
                        </div>
                        <div id="invitation-container" class="invitation-list__body">
                        </div>
                    </div>
                    <div id="empty-invitation-list" class="invitation-list mt-3" style="display:none;">
                        <div class="d-flex flex-column align-items-center my-5">
                            <img class="mb-3" src="/images/svg/quickpay/mail-circle-large@2x.svg" height="44" width="44">
                            <div class="headline-5 mb-2">Invitations</div>
                            <div class="body-1 grey-text mb-4">Invited people</div>
                            <div class="body-2 mb-4">You have no invited guests yet. Click the <span class="green-text">Invite button</span> to start.</div>
                            <button id="inviteGuestsButton2" class="btn btn--paybee btn--green button disabled" style="min-width: 125px;">Invite Guests</button>
                        </div>
                    </div>
                </div>
                <div id="invitation-list-instruction">
                    <div class="d-flex flex-column align-items-center my-5">
                        <img class="mb-3" src="/images/svg/quickpay/mail-circle-large@2x.svg" height="44" width="44">
                        <div class="headline-5 mb-2">Invitations</div>
                        <div class="body-1 mb-5">This functionality is currently disabled.</div>
                        <div class="instruction p-4">
                            <div class="body-2 mb-2">Instruction to enable invitations:</div>
                            <div class="body-2">1. Please switch on "Collect Guest Information"</div>
                            <div class="body-2">2. Please switch on "Enable Guest Invitation"</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
